// extracted by mini-css-extract-plugin
export default {"logo":"Logos_logo__w9zLF","bluelineIcon":"Logos_bluelineIcon__bPgkT"};